$(function ()  {


    //Solution carousell
    if($('.section__carousel').length > 0) {
        $(document).ready(function() {
            if ( $(window).width() < 920 ) {
                solCarousell();
            } else {
                $('.section__carousel').addClass('disabledCar');
            }
        });

        $(window).resize(function() {
            if ( $(window).width() < 920 ) {
                solCarousell();
                $('.section__carousel').removeClass('disabledCar');
            } else {
                stopCarousel();
                $('.section__carousel').addClass('disabledCar');
            }
        });
    }


    if($('.reviews__carousel').length > 0) {
        revCarousell();
    }


    //Docks carousell
    if($('.buklet__carousel').length > 0) {
        $(document).ready(function() {
            if ( $(window).width() < 920 ) {
                docksCarousell();
            } else {
                $('.buklet__carousel').addClass('disabledCar');
            }
        });

        $(window).resize(function() {
            if ( $(window).width() < 920 ) {
                docksCarousell();
                $('.buklet__carousel').removeClass('disabledCar');
            } else {
                stopDocksCarousel();
                $('.buklet__carousel').addClass('disabledCar');
            }
        });
    }



    //P[rn sibnav
    $('.header__nav .menu-item-has-children > a').click(function (e) {
        if($(window).width() < 920 && !$(this).hasClass('active')) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).siblings('ul').slideDown(300);
        }
    })


    //Connect
    $('.connectCat').change(function () {
        setTimeout(function() {
            if($('.connect__quiqcont.hidden').hasClass('wpforms-conditional-show')) {
                $('.connect__quiqcont').addClass('showedConn');
            } else {
                $('.connect__quiqcont').removeClass('showedConn');
            }
        }, 100);

    });

    //Маска
    jQuery(function($){
        if($('.inputTel').length > 0) {
            setTimeout(function() {
                if($('.inputTel').find('.iti__flag').hasClass('iti__ua')) {
                    $(".inputTel input[type='tel']").mask("099 999 99 99");
                }
            }, 1000);

            $('.iti__standard').click(function () {
                if($(this).attr('data-country-code') === 'ua') {
                    $(".inputTel input[type='tel']").mask("099 999 99 99");
                } else {
                    $(".inputTel input[type='tel']").unmask();
                }
            });
        }
    });



    //Form submit
    $(".wpforms-submit").click(function() {
        var
            form = $(this).closest('form');

        setTimeout(function() {
            var
                formErrors = form.find('.wpforms-has-error').length;

            if(formErrors < 1) {
                setTimeout(function() {
                    $('#popup__thanks').fadeIn(400);
                    $('body').addClass('overHide');
                    form[0].reset();
                }, 1000);

            }
        }, 100);
    });


    if($(window).width() > 1120) {
        $('html, body').stop().animate({'scrollTop': $('.category__listem').offset().top - 20  }, 500, 'swing', function () {

        });
    }


    //Download field
    $('.formDownload input').change(function (e) {
        var
            $this = $(this),
            thisVal = e.target.files[0].name,
            thisLabel = $this.prev('label');

        $('.padtedFile').remove();
        thisLabel.append('<span class="padtedFile">&nbsp;-&nbsp;'+thisVal+'</span>')
    });



});


//Scroll header
$(window).scroll(function () {
    var
        scrollTop = $(this).scrollTop();

    if(scrollTop > 20) {
        $('.header').addClass('headerScroll');
    } else {
        $('.header').removeClass('headerScroll');
    }
});


//Open nav
function openNav() {
    event.preventDefault();

    $('.mobile__navcont').toggleClass('openedNav');
    $('.header').toggleClass('openedNav');
    $('body').toggleClass('overHidePt');
}


//Search
function searchControl() {
    event.preventDefault();

    var
        header = $('.header'),
        searchForm = $('.header__serchform'),
        searchInput = $('#searchInput');

    if(!header.hasClass('openedSearch')) {
        header.addClass('openedSearch');
        searchInput.focus();
    } else {
        if(searchInput.val().length > 0) {
            header.addClass('searching');
            searchForm.submit();
        }
    }

}

function focusOut() {
    var
        header = $('.header');

    setTimeout(function() {
        if(!header.hasClass('searching')) {
            header.removeClass('openedSearch');
        }
    }, 100);
}


//Solution carousell
function solCarousell() {
    var owl = $(".section__carousel").owlCarousel({
        smartSpeed: 500,
        mouseDrag: true,
        autoplay: false,
        center: false,
        addClassActive : true,
        loop: true,
        dots: true,
        nav: false,
        touchDrag: true,
        dotsSpeed: 500,
        stagePadding: 0,
        responsive : {
            0 : {
                items: 1,
                margin: 0,
            },
            600 : {
                items: 2,
                margin: 16,
            }
        }
    });

}

function stopCarousel() {
    var owl = $('.section__carousel');
    owl.trigger('destroy.owl.carousel');
    owl.addClass('disabledCar');
}



//Review carousell
function revCarousell() {
    var owl = $(".reviews__carousel").owlCarousel({
        smartSpeed: 500,
        mouseDrag: true,
        autoplay: false,
        center: true,
        margin: 0,
        items: 1,
        addClassActive : true,
        loop: true,
        nav: true,
        touchDrag: true,
        dotsSpeed: 500,
        stagePadding: 0,
    });

    owl.on('changed.owl.carousel', function(event) {
        $('.openedRev').removeClass('openedRev');
    })
}

function revAll($this) {
    event.preventDefault();

    var
        thisRev = $this.closest('.reviews__item');

    thisRev.addClass('openedRev');
}



//Docks carousell
function docksCarousell() {
    var owl = $(".buklet__carousel").owlCarousel({
        smartSpeed: 500,
        mouseDrag: true,
        autoplay: false,
        center: false,
        margin: 14,
        addClassActive : true,
        loop: true,
        dots: true,
        nav: false,
        touchDrag: true,
        dotsSpeed: 500,
        stagePadding: 0,
        responsive : {
            0 : {
                items: 1,
                margin: 12,
            },
            500 : {
                items: 2,
                margin: 14,
            }
        }
    });

}

function stopDocksCarousel() {
    var owl = $('.buklet__carousel');
    owl.trigger('destroy.owl.carousel');
    owl.addClass('disabledCar');
}



//Map
function initMap() {
    if($('#map').length > 0) {
        var
            mapLat = $('#map').data().lat,
            mapLng = $('#map').data().lng,
            mapTitle = $('#map').data().title;

        var myLatLng = {lat: mapLat, lng: mapLng};

        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center: myLatLng
        });

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            title: mapTitle
        });
    }
}




//Popup
function openPopup($this) {
    event.preventDefault();

    var
        thisHref = $this.attr('href'),
        thisPop = $(thisHref);

    thisPop.fadeIn(300);
    $('body').addClass('overHide');
}


function closePopup() {
    event.preventDefault();

    $('.popup').fadeOut(300);
    $('body').removeClass('overHide');
}


//Read more text in About
function readTextAb($this) {
    event.preventDefault();

    var
        theText = $this.siblings('.hidenText'),
        theTextH = theText.find('*').innerHeight();

    theText.css({'height' : theTextH+'px'});

    setTimeout(function() {
        theText.removeClass('hidenText');
        theText.css({'height' : 'auto'});
        $this.remove();
    }, 400);
}



